const PrioritiesChallenge2InitialText ="You are reviewing some discretionary (optional) " +
    "expenses.  Based on your current monthly net income, the total amount of the optional expenses " +
    "must be greater than $||minAmount|| and cannot exceed $||maxAmount||.  Move the items from the " +
    "'Monthly Expenses' to the 'Items Selected' column to indicate the items that you " +
    "would choose with the money that you have.  Click the 'Done' button when complete."
export default PrioritiesChallenge2InitialText